import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const CwrWelcomeBanner: LoadableType<{
	contentId: string;
	isLivePage: boolean;
}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-CwrWelcomeBanner" */ '../src/components/cwr-welcome-banner/CwrWelcomeBanner.tsx'
			)
		).CwrWelcomeBanner,
});

// eslint-disable-next-line check-react-ssr-usage/no-static-and-loadable-export
export { CWR_WELCOME_QUERY_PARAM } from '../src/components/cwr-welcome-banner/CwrWelcomeBanner.tsx';
export type { CwrWelcomeVariant } from '../src/components/cwr-welcome-banner/CwrWelcomeBanner.tsx';
